import type {
  MatchDetailDto,
  TeamMatchDetailDto,
} from '@/api/backoffice-schemas';
import { TeamDisplay } from './TeamDisplay';

interface TeamsProps {
  team1?: TeamMatchDetailDto;
  team2?: TeamMatchDetailDto;
  status: string;
  draw?: boolean;
  winner?: MatchDetailDto['winner'];
}

export const Teams = ({ team1, team2, status, draw, winner }: TeamsProps) => {
  const isTeam1Winner =
    status === 'finished' &&
    !draw &&
    winner?.externalId === team1?.team?.externalId;
  const isTeam2Winner =
    status === 'finished' &&
    !draw &&
    winner?.externalId === team2?.team?.externalId;

  return (
    <div className="flex w-[9.813rem] flex-col gap-2 md:w-[12.563rem]">
      {team1 && (
        <TeamDisplay
          draw={draw}
          isWinner={isTeam1Winner}
          status={status}
          teamMatch={team1}
        />
      )}
      {team2 && (
        <TeamDisplay
          draw={draw}
          isWinner={isTeam2Winner}
          status={status}
          teamMatch={team2}
        />
      )}
    </div>
  );
};
